import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  password: {
    'input::-ms-reveal': { display: 'none' },
  },
  layout: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    minHeight: 'calc(100vh - 80px)',
    padding: `0 ${theme.spacing(1.5)}`,
    [theme.breakpoints.down('lg')]: {
      height: 'calc(100vh - 70px)',
    },
    [theme.breakpoints.down('md')]: {
      height: 'calc(100vh - 54px)',
    },
  },
  root: {
    maxWidth: 400,
    width: '100%',
  },
  input: {
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(2),
    },
  },
  button: {
    margin: `${theme.spacing(5)} auto 0`,
    width: 130,
    minHeight: 44,
    [theme.breakpoints.down('lg')]: {
      width: 180,
    },
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(4),
    },
  },
  header: {
    marginBottom: theme.spacing(5),
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(4),
    },
  },
  error: {
    marginTop: theme.spacing(3),
    color: theme.palette.primary1,
    fontSize: 14,
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(2),
      fontSize: 12,
    },
  },
}));
